import "../../styles/theme.scss";
import "../../styles/theme.scss.liquid";

import Rivetjs from 'rivets';
import Modernir from "../vendors/modernizr.min.js";
import Instafeed from 'instafeed.js';
import Flickity from 'flickity-imagesloaded';

window.rivets = Rivetjs
window.Flickity = Flickity


/* COMPONENTS JS + CSS */
import Header 			from     "../components/header.js";
import Cart         from     "../components/cart.js";
import Faq          from     "../components/faq";
import "../components/footer.js";
import "../components/instagram.js";

/* LIBRARIES */
import 'lazysizes';
console.log('THEME JS');



// GET DATA FROM FRONT END
var cartJson = JSON.parse($('[data-json-cart]')[0].innerHTML);
window.kercambreCart = new Cart(cartJson)



class KercambreTheme {
  constructor() {
    var _this = this;
    _this.url 	       = new URL(window.location.href);
    _this.header 	     = new Header();
    $( document ).on( "updateUrlParam", function( event, param1, param2 ) {
      _this.updateUrlParam(param1, param2)
    });
    _this.globalListener();
    _this.instafeed();
    _this.initSearch();
    _this.lookForVimeo();
    _this.addScrollTop();

    document.addEventListener('aos:in', ({ detail }) => {
      // console.log('animated in', detail);
    });
    document.addEventListener('aos:out', ({ detail }) => {
      // console.log('animated out', detail);
    });

    if ($("#account").length) {
      _this.account();
    }
    if ( $('.faq').length ) {
      _this.faq = new Faq()
    }
  }
  updateUrlParam(k, v){
		// console.log("updateUrl " + k + " "+ v);
		if ( this.url.searchParams.has(k) ) {
			this.url.searchParams.set(k, v);
		}else{
			this.url.searchParams.append(k, v);
		}
		if (!history.replaceState) {
			return;
		}
		window.history.replaceState({path: this.url.href}, '', this.url.href);
	}
  globalListener(){
		$('[action-modal-close]').click(function(event) {
			$(this).closest('.modal').removeClass('modal--visible');
		});

		$('[action-modal-show]').click(function(event) {
			var target = '.' + $(this).attr('action-modal-show');
			$(target).addClass('modal--visible');
		});

    $(".modal").click(function(){
      $(".modal").removeClass("modal--visible");
    });
    $(".modal__content").click(function(e){
      e.stopPropagation();
    });


	}
  instafeed(){
    var _this = this;
    if ( $('#instafeed').length ) {
      _this.instafeed = new Instafeed({
        get: 'user',
        userId: $("#instafeed").data('id'),
        accessToken: $("#instafeed").data('token') ,
        resolution: 'standard_resolution',
        sortBy: 'most-recent',
        limit: 6,
        autoPlay: parseInt($("#instafeed").data('autoplay')),
        template: '<div class="instafeed__cell"><a href="{{link}}" target="_blank" rel="nofollow"><img src="{{image}}" ></a></div>',
        links: false,
        after: function(){
            _this.instafeed_slider = new Flickity("#instafeed", {
              cellAlign: "left",
              contain: true,
              wrapAround: true,
              prevNextButtons: false,
              watchCSS: true,
              pageDots: false
            })
          }
      });
      this.instafeed.run();
    }
  }
  initSearch(){
    $('[action-toggle-search]').click(function(event) {
      /* Act on the event */
      $('.header__search').toggleClass('active');
    });

    $("body").click(function(){
      $(".header__search").removeClass("active");
    });
    // Prevent events from getting pass .popup
    $(".header__search").click(function(e){
      e.stopPropagation();
    });
  }
  lookForVimeo(){
    $(document).ready(function() {
      var players = []
      $('[video]').each(function() {
        var player = new Vimeo.Player($(this).find("iframe").get(0));
        // console.log($(this).position().top);
        player.pause();
        players.push({
            player,
            top: $(this).position().top,
            status: "paused"
        })
      });
      var viewportHeight = $(window).height();
      $(window).on('scroll', function() {

        var scrollPos = $(window).scrollTop();
        // console.log("scrollPos is : " + scrollPos);

        for(var i=0; i<players.length;i++) {
          // console.log("------------------------------------");
          var elementFromTop = players[i].top - scrollPos;
          // console.log("elementFromTop is : " + elementFromTop);

          // console.log("viewportHeight is " + viewportHeight);

          var currentStatus = players[i].status;
          // console.log("current player status is " + currentStatus);

          // if (elementFromTop < 0) {
          //   players[i].player.pause();
          // }

          // Si
          var status = (elementFromTop > 0 && elementFromTop < viewportHeight ) ? "play" : "pause";
          // console.log("now should be "+ status);
          // console.log("------------------------------------");

          if(players[i].status != status) {
              players[i].status = status;
              players[i].player[status]();
              // console.log(i, status);
          }
        }
      });
    });
  }
  account(){
    var _this = this;
    // JUSTE GERER SI PARAM DANS LURL DE LA PAGE ACCOUNT
    var test = _this.url.searchParams.has('view');

    if (test) {
      console.log("jai trouvé un param");
      var param_value = _this.url.searchParams.get('view');
      // AFFICHER LES BLOCS LIES A CETTE VALEUR
      $('.account__block').hide();
      $('.account__block[data-name="'+param_value+'"]').show();


      // CHANGER LA NAV
      $('.account__nav-item').removeClass('account__nav-item--active');
      $('.account__nav-item[data-name="'+ param_value +'"]').addClass('account__nav-item--active');

      // CHANGER LA MOBILE NAV
      console.log(_this.url.pathname);
      $('.account__mobilenav').val(_this.url.pathname+ _this.url.search);

      // CHANGER LE TITLE
      var title = $('.account__nav-item[data-name="'+ param_value +'"] a').text();
      $('.page__header-title').text(title);
      $('.page__header p').text('');

    }else {
      console.log("j'ai pas trouvé de param");
    }
  }
  addScrollTop(){
    /*================ HACK ON COLLECTION PAGE WHEN SCROLL ================*/
    if ( $('[data-scroll-top]').length ) {
     var elem = `<div class="scrolltop" style="display:none">
     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 64 64" enable-background="new 0 0 64 64">
       <g>
         <path fill="#1D1D1B" d="M3.352,48.296l28.56-28.328l28.58,28.347c0.397,0.394,0.917,0.59,1.436,0.59c0.52,0,1.04-0.196,1.436-0.59   c0.793-0.787,0.793-2.062,0-2.849l-29.98-29.735c-0.2-0.2-0.494-0.375-0.757-0.475c-0.75-0.282-1.597-0.107-2.166,0.456   L0.479,45.447c-0.793,0.787-0.793,2.062,0,2.849C1.273,49.082,2.558,49.082,3.352,48.296z"/>
       </g>
     </svg>
     TOP
     </div>`
     $('body').append(elem);
     $(window).on("scroll", function() {
       // var scrollHeight = $(document).height();
       // var scrollPosition = $(window).height() + $(window).scrollTop();
       if ($(window).scrollTop() > 300) {
         $('.scrolltop').show();
       }else{
         $('.scrolltop').hide();
       }
     });
    }
    $('.scrolltop').click(function(event) {
     $([document.documentElement, document.body]).animate({
         scrollTop: $("body").offset().top
     }, 1000);
    });
  }
}
window.kercambreTheme = new KercambreTheme();



class Login {
  constructor() {
    console.log("login js");
    $('[action-show-reset]').on('click', function(event) {
      event.preventDefault();
      $('.form__login').fadeOut(400, function() {
        $('.form__reset').fadeIn(400, function() {
        });
      });
    });
  }
}
var login = new Login();



var headerHeight = $('.header').height();
document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

window.addEventListener('resize', () => {
  // We execute the same script as before
  headerHeight = $('.header').height();
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

});




